import { createContext, useContext, ReactNode } from 'react';
import { useDynamicTheme } from '../hooks/useDynamicTheme';

interface ThemeContextType {
  logo?: string;
  primaryColor?: string;
  brandName?: string;
  brandLabel?: string;
  isConfigured: boolean;
  isLoading: boolean;
  error: any;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
  baseUrl?: string;
}

export function ThemeProvider({ children, baseUrl = "prove" }: ThemeProviderProps) {
  const themeData = useDynamicTheme(baseUrl);

  return (
    <ThemeContext.Provider value={themeData}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
